<form class="generalFormTracsa" [formGroup]="form" (ngSubmit)="saveForm()">
  @if (showInterestField()) {
  <label
    [ngClass]="{
      errorForm: submitted() && form.controls['web_area_interes__c'].errors
    }"
    for="area"
    >Área de interés:*
    <select
      id="area"
      formControlName="web_area_interes__c"
      (change)="validQuote($event)"
      [ngClass]="{
        errorForm: submitted() && form.controls['web_area_interes__c'].errors
      }"
    >
      <option value="">Selecciona una área de interés</option>
      @for (interest of interestList; track $index) {
      <option [value]="interest">
        {{ interest }}
      </option>
      } @for (case of caseList; track $index) { @if (interested()) {
      <option [value]="case">
        {{ case }}
      </option>
      } }
    </select>
    <p
      class="errorText"
      [ngClass]="{
        activeErrorText: submitted() && form.controls['web_area_interes__c'].errors
      }"
    >
      Este campo es necesario
    </p>
  </label>
  } @if (isRental()) {
  <div class="twoFields">
    <div>
      <label
        [ngClass]="{
          errorForm: submitted() && form.controls['TSC_InicioRenta__c'].errors
        }"
        for="rentDate"
        >Inicio de la renta*
        <input
          matInput
          [matDatepicker]="picker"
          (click)="picker.open()"
          placeholder="Selecciona un día"
          [min]="minDate"
          class="w-100"
          id="rentDate"
          formControlName="TSC_InicioRenta__c"
          [ngClass]="{
            errorForm: submitted() && form.controls['TSC_InicioRenta__c'].errors
          }"
        />
        <mat-datepicker #picker></mat-datepicker>
        <p
          class="errorText"
          [ngClass]="{
            activeErrorText: submitted() && form.controls['TSC_InicioRenta__c'].errors
          }"
        >
          Este campo es necesario
        </p>
      </label>
    </div>

    <div>
      <label
        [ngClass]="{
          errorForm: submitted() && form.controls['TSC_DuracionRenta__c'].errors
        }"
        for="rentDuration"
        >Duración de la renta*
        <select
          id="rentDuration"
          formControlName="TSC_DuracionRenta__c"
          [ngClass]="{
            errorForm: submitted() && form.controls['TSC_DuracionRenta__c'].errors
          }"
        >
          <option value="">Selecciona un periodo</option>
          <option value="Menos de 2 semanas">Menos de 2 semanas</option>
          <option value="2 semanas">2 semanas</option>
          <option value="3 semanas">3 semanas</option>
          <option value="1 mes">1 mes</option>
          <option value="2 meses">2 meses</option>
          <option value="3 meses">3 meses</option>
          <option value="4 meses">4 meses</option>
          <option value="5 meses">5 meses</option>
          <option value="6 meses">6 meses</option>
          <option value="más de 6 meses">Más de 6 meses</option>
        </select>
        <p
          class="errorText"
          [ngClass]="{
            activeErrorText: submitted() && form.controls['TSC_DuracionRenta__c'].errors
          }"
        >
          Este campo es necesario
        </p>
      </label>
    </div>
  </div>
  }
  <div class="twoFields">
    <div>
      <label
        [ngClass]="{
          errorForm: submitted() && form.controls['web_nombres__c'].errors
        }"
        for="name"
        >Nombre:*
        <input
          type="text"
          id="name"
          placeholder="Escribe tu nombre"
          formControlName="web_nombres__c"
          [ngClass]="{
            errorForm: submitted() && form.controls['web_nombres__c'].errors
          }"
        />
        <p
          class="errorText"
          [ngClass]="{
            activeErrorText: submitted() && form.controls['web_nombres__c'].errors
          }"
        >
          Este campo es necesario
        </p>
      </label>
    </div>
    <div>
      <label
        [ngClass]="{
          errorForm: submitted() && form.controls['web_Apellidos__c'].errors
        }"
        for="lastName"
        >Apellidos:*
        <input
          type="text"
          id="lastName"
          placeholder="Escribe tus apellidos"
          formControlName="web_Apellidos__c"
          [ngClass]="{
            errorForm: submitted() && form.controls['web_Apellidos__c'].errors
          }"
        />
        <p
          class="errorText"
          [ngClass]="{
            activeErrorText: submitted() && form.controls['web_Apellidos__c'].errors
          }"
        >
          Este campo es necesario
        </p>
      </label>
    </div>
  </div>
  <div class="twoFields">
    <div>
      <label
        [ngClass]="{
          errorForm: submitted() && form.controls['web_telefono__c'].errors
        }"
        for="phone"
        >Teléfono:*
        <input
          type="text"
          id="phone"
          placeholder="Ingresa un número con 10 dígitos"
          (input)="onlyNumberKey($event)"
          formControlName="web_telefono__c"
          [ngClass]="{
            errorForm: submitted() && form.controls['web_telefono__c'].errors
          }"
        />
        <p
          class="errorText"
          [ngClass]="{
            activeErrorText: submitted() && form.controls['web_telefono__c'].errors
          }"
        >
          Este campo es necesario
        </p>
      </label>
    </div>
    <div>
      <label
        [ngClass]="{
          errorForm: submitted() && form.controls['web_email__c'].errors
        }"
        for="email"
        >Correo electrónico:*
        <input
          class="errorForm"
          type="text"
          id="email"
          placeholder="Ingresa tu correo electrónico"
          formControlName="web_email__c"
          [ngClass]="{
            errorForm: submitted() && form.controls['web_email__c'].errors
          }"
        />
        <p
          class="errorText"
          [ngClass]="{
            activeErrorText: submitted() && form.controls['web_email__c'].errors
          }"
        >
          Este campo es necesario
        </p>
      </label>
    </div>
  </div>
  <div class="twoFields">
    <div>
      <label
        [ngClass]="{
          errorForm: submitted() && form.controls['web_estado__c'].errors
        }"
        for="state"
        >Estado:*
        <select
          id="state"
          formControlName="web_estado__c"
          (change)="selectState($event.target)"
          [ngClass]="{
            errorForm: submitted() && form.controls['web_estado__c'].errors
          }"
        >
          <option value="">Selecciona un estado</option>
          @for (item of states(); track $index) {
          <option [value]="item.nombre">
            {{ item.nombre }}
          </option>
          }
        </select>
        <p
          class="errorText"
          [ngClass]="{
            activeErrorText: submitted() && form.controls['web_estado__c'].errors
          }"
        >
          Este campo es necesario
        </p>
      </label>
    </div>
    <div>
      <label
        [ngClass]="{
          errorForm: submitted() && form.controls['web_municipio__c'].errors
        }"
        for="municipality"
        >Municipio:*
        <select
          id="Municipio"
          formControlName="web_municipio__c"
          [ngClass]="{
            errorForm: submitted() && form.controls['web_municipio__c'].errors
          }"
        >
          <option value="">Selecciona un municipio</option>
          @for (item of selectedMunicipalities(); track $index) {
          <option [value]="item">
            {{ item }}
          </option>
          }
        </select>
        <p
          class="errorText"
          [ngClass]="{
            activeErrorText: submitted() && form.controls['web_municipio__c'].errors
          }"
        >
          Este campo es necesario
        </p>
      </label>
    </div>
  </div>
  <div class="twoFields">
    <div>
      <label
        [ngClass]="{
          errorForm: submitted() && form.controls['web_empresa__c'].errors
        }"
        for="company"
        >Empresa:*
        <input
          type="text"
          id="company"
          placeholder="Nombre de la empresa"
          formControlName="web_empresa__c"
          [ngClass]="{
            errorForm: submitted() && form.controls['web_empresa__c'].errors
          }"
        />
        <p
          class="errorText"
          [ngClass]="{
            activeErrorText: submitted() && form.controls['web_empresa__c'].errors
          }"
        >
          Este campo es necesario
        </p>
      </label>
    </div>
    <div>
      <label
        [ngClass]="{
          errorForm: submitted() && form.controls['web_cp__c'].errors
        }"
        for="cp"
        >Código postal:*
        <input
          class="errorForm"
          type="text"
          id="cp"
          placeholder="Código postal de la empresa"
          formControlName="web_cp__c"
          (input)="onlyNumberKey($event)"
          [ngClass]="{
            errorForm: submitted() && form.controls['web_cp__c'].errors
          }"
        />
        <p
          class="errorText"
          [ngClass]="{
            activeErrorText: submitted() && form.controls['web_cp__c'].errors
          }"
        >
          Este campo es necesario
        </p>
      </label>
    </div>
  </div>
  <label for="comments"
    >Envíanos tus dudas o comentarios (opcional)
    <textarea
      formControlName="Description"
      [ngClass]="{
        errorForm: submitted() && form.controls['Description'].errors
      }"
      id="descriptionComments"
      rows="3"
      placeholder="Escribe un mensaje"
    ></textarea>
  </label>
  <mat-checkbox
    class="custom-checkbox"
    formControlName="web_tyc__c"
    [ngClass]="{
      errorForm: submitted() && form.controls['web_tyc__c'].errors
    }"
  >
    He leído y acepto el
    <a routerLink="/legales/aviso-de-privacidad" target="_blank"> Aviso de privacidad </a></mat-checkbox
  >
  <mat-checkbox class="custom-checkbox" formControlName="web_boletin__c"
    >Deseo recibir noticias</mat-checkbox
  >
  <button class="btnTracsa btnYellow" type="submit" id="enviarFormulario">Enviar</button>
</form>
@if (loading()) {
<div class="spinnerLoading">
  <mat-spinner mode="indeterminate"></mat-spinner>
  @if (errorSend()) {
  <p>Error, recargue la página e intente de nuevo</p>
  }
</div>
}
